import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSecurity = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1797_768)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10 8H5V11H10V8Z",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 8V6.2C6.00119 5.88203 6.1596 5.57736 6.44065 5.35252C6.7217 5.12768 7.10254 5.00095 7.5 5V5C7.89746 5.00095 8.2783 5.12768 8.55935 5.35252C8.8404 5.57736 8.99881 5.88203 9 6.2V8",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13 9.25806C13 10.798 12.5324 12.2104 11.4775 13.2993C10.4226 14.3882 8.99184 15 7.5 15C6.00816 15 4.57742 14.3882 3.52252 13.2993C2.46763 12.2104 2 10.798 2 9.25806V2.54839L7.5 1L13 2.54839V9.25806Z",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1797_768",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			fill: "currentColor",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIconSecurity;
